import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=caa17400&scoped=true&"
import script from "./IframeModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IframeModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=caa17400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa17400",
  null
  
)

export default component.exports